import isProd from './isProduction.ts'
import { HEADING, SUBHEADING } from './defaults'

export const endpoints = (prod = isProd()) => ({
  authApiUrl: prod ? 'https://www.citationmachine.net/api/auth' : 'https://playground.citationmachine.net/api/auth',
  editorBaseUrl: prod ? 'https://writing.citationmachine.net' : '//writing-playground.citationmachine.net',
})

const cm = ({
  site = 'citationmachine',
  headingText = HEADING,
  subheadingText = SUBHEADING,
  pasteOnly = false,
  alignText = 'center',
  initRSW = true,
  initFreshToken = true,
} = {}) => {
  const { editorBaseUrl, authApiUrl } = endpoints()

  return {
    headingText,
    subheadingText,
    authApiUrl,
    editorBaseUrl,
    pasteOnly,
    alignText,
    site,
    initFreshToken,
    initRSW,
  }
}

export default cm
